<script setup lang="ts">
import type { Placement, Strategy } from '@floating-ui/vue'

const props = withDefaults(
  defineProps<{
    label: string
    placement?: Placement
    offsetSize?: number
    strategy?: Strategy
    class?: string
    disabled?: boolean
  }>(),
  {
    placement: 'bottom',
    offsetSize: 7,
    disabled: false,
  }
)

const {
  anchor,
  floating: tooltip,
  floatingStyles,
} = useUiFloating({
  strategy: props.strategy,
  placement: props.placement,
  offsetSize: props.offsetSize,
})

const open = ref(false)

function onMouseEnter() {
  if (!props.disabled) {
    open.value = true
  }
}

function onMouseLeave() {
  open.value = false
}

watch(
  () => props.disabled,
  (disabled) => {
    if (disabled) {
      open.value = false
    }
  }
)
</script>

<template>
  <div>
    <div
      ref="anchor"
      class="h-full w-fit"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <slot></slot>
    </div>
    <div v-if="open" :style="floatingStyles" ref="tooltip" class="z-50 px-2">
      <Transition
        appear
        enterActiveClass="motion-safe:transition duration-300"
        enterFromClass="opacity-0 translate-y-1"
        enterToClass="opacity-100 translate-y-0"
        leaveActiveClass="motion-safe:transition duration-200"
        leaveFromClass="opacity-100 translate-y-0"
        leaveToClass="opacity-0 translate-y-1"
      >
        <div
          :class="
            cn(
              'left-0 top-0 max-w-[100vw] text-wrap rounded-lg bg-primary px-2 py-0.5 text-sm text-primary-contrast',
              props.class
            )
          "
        >
          {{ props.label }}
        </div>
      </Transition>
    </div>
  </div>
</template>
